/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: jordan.lu jordan.lu@oppo.com
 * @LastEditTime: 2024-05-15 15:29:27
 * @FilePath: \sns-user-frontend\src\main.js
 * @Description: 
 */
import { createApp } from 'vue'

import App from './App'
import { routerInstance, resetRouter } from './router'
import pinia from './stores/store';
import jsBridge from '@/jsBridgeApi';
// 工具
import filter from '@/utils/filter'
// ga自主埋点方法
import ga from '@/hooks/gtm'
// 国际化
import vueI18n from './lang'
import longPress from '@/directive/longPress.js'
import Http from '@/service'
// 用于处理部分浏览器高度没有将搜索栏计算在内/获取移动端浏览器搜索栏高度
import vhCheck from 'vh-check'
// 消除chrome被动事件警告（Passive Event Listeners）
// import 'default-passive-events'
// svg-icon支持
import 'virtual:svg-icons-register'
/** 
 * css 样式
 * reset.css 样式重置
 * base.css 基础样式
 * main.css 主要样式
 */
// import './assets/style/reset.css'
// import './assets/style/base.postcss'
// import './assets/style/cookieManage.css'
// import './style/figmaVariable.postcss'
import 'vant/es/toast/style'

// Element plus 方法类组件
import { showToast } from 'vant';
import { setCookie } from '@/utils'
// 自定义指令
import { storeToRefs } from 'pinia';
import { useSystemStore } from '@/stores/system'
import { useUserStore } from '@/stores/user'

vhCheck('browser-address-bar');
const app = createApp(App)

const isAppMarket = (navigator.userAgent.toLowerCase().includes('appmarket') || location.search.includes('fromAppRate'))
const isApp = (window.HeytapNativeApi && !!window.HeytapNativeApi.invoke) || /usercenter/i.test(navigator.userAgent) || (!!window.OppoStoreClientStoreJS && !!window.OppoStoreClientBaseJS && !!window.OppoStoreClientUserJS) || /ONEPLUS/i.test(navigator.userAgent) || !!window.OnePlusClientBaseJS || navigator.userAgent.toLowerCase().includes('oppocommunity') || isAppMarket

if (isApp) {
  document.body.style.background = 'transparent'
  try {
    // jsBridge
    for (const apiKey in jsBridge) {
      app.config.globalProperties[`$${apiKey}`] = jsBridge[apiKey]
    }
    jsBridge?.getToken()
    jsBridge?.closeLoading()
  } catch (e) {}
  setTimeout(() => {
    document.body.style.background = 'var(--background-body)'
  }, 1000);
}


// 暗色检测
const onDetectDarkMode = () => {
  const systemStore = useSystemStore()  
  const { isDark } = storeToRefs(systemStore)
  let darkModeDetective =  window.matchMedia('(prefers-color-scheme: dark)').matches 
  if (isApp) {
    darkModeDetective = window.HeytapTheme?.isNight && typeof (window.HeytapTheme.isNight) === 'function' && window.HeytapTheme.isNight()
  }
  const isDarkMode = document.getElementsByTagName("body")[0].className.includes('dark')
  if (darkModeDetective && !isDarkMode) {
    document.getElementsByTagName("body")[0].className += ' dark'
  }
  if (!darkModeDetective) {
    document.getElementsByTagName("body")[0].className = document.getElementsByTagName("body")[0].className.replace(' dark', '')
  }
  isDark.value = document.body.className.includes('dark')
  try {
    // hideTerminalBar 第二个参数，设置为 2，意思是不使用全屏
    isApp && jsBridge?.hideTerminalBar(window.HeytapTheme.isNight() ? 2 : 1, 2)

  } catch (e){
  }
}

if (!isAppMarket) {
  setInterval(() => {
    const systemStore = useSystemStore()  
    const { isWap } = storeToRefs(systemStore)
    if (isWap.value) {
      onDetectDarkMode()
    }
  }, 100);
}


// 会员积分页嵌入oppo列表
if (location.href.includes('abroadList')) {
  // 子页面接收消息
  window.addEventListener("message",(e) => {
    const { data = {}, origin = "" } = e;
    if (origin.indexOf("wanyol.com") < 0 && origin.indexOf("oppo.com") < 0) return false;
    if (e && Object.keys(data).length) {
      const { token } = data;
      setCookie("token", token || '');
    }
  }, false);
} 

app.config.globalProperties.$http = Http
app.config.globalProperties.$toast = ({message, position, duration, className, onClose}) => {
  const systemStore = useSystemStore()  
  const { isWeb } = storeToRefs(systemStore)
  showToast({
    message,
    position: isWeb.value ? 'top' : 'bottom',
    duration: duration || 3000,
    className: className || '',
    teleport: 'body',
    onClose
  })
}
// filter
for (const filterKey in filter) {
  app.config.globalProperties[`$${filterKey}`] = filter[filterKey]
}

// gtm埋点
app.config.globalProperties.$ga = ga

// 长按自定义指令
app.directive('longPress', longPress)

async function initApp () {
  app.use(pinia)
  // // 成长体系内测用户
  // try {
  //   const userStore = useUserStore() 
  //   await Http.membershipApi.queryIsBetaUser().then(res => {
  //     userStore.isBetaUser = res.data
  //   })
  // } catch {}
  // 心跳，用于刷新登录态有效期
  await Http.authorize.heartBeat()
  const systemStore = useSystemStore()  
  await systemStore.setCloudConfig()  // 获取云配置
  // 拉新活动受邀人不调用用户详情
  if (!location.pathname.includes('invitation') && !location.pathname.includes('abroadList')) {
    const userStore = useUserStore() 
    await userStore.requestUserInfo() // 获取用户数据
  }
  app.use(vueI18n)
  resetRouter()
  app.use(routerInstance)
  
  app.mount('#app')
}

initApp()

